module.exports = __webpack_public_path__ + "static/img/celoscope-detail-36.cc347a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-36.jpg
// module id = 2u2s
// module chunks = 51